module.exports = __webpack_public_path__ + "static/media/SM_WC_End@2x.3f5be465.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/SM_WC_End@2x.png
// module id = 175
// module chunks = 0